import { cn } from '@/lib/utils/tw-merge';
import type { UiSliderFadeProps } from './UiSlider.types';

/** Gradient over an edge the track runs on past — the design's `.pm-fade`. */
export function UiSliderFade({ side, visible }: UiSliderFadeProps) {
    return (
        <div
            aria-hidden="true"
            className={cn('card-track-fade', `card-track-fade--${side}`, visible && 'card-track-fade--visible')}
        />
    );
}
